export const ChangeLinks = (() => {
    const {
        site_url = null,
        path,
    } = window.multisite_info;

    if (['https://shipbob.vipdev.lndo.site', 'https://www.shipbob.com', 'https://go.shipbob.com'].includes(site_url) || !site_url) {
        return null;
    }
    
    const processLinks = () => {
        Array.from(document.querySelectorAll('a:not(.locale)')).map((link_element) => {
            const link = link_element.pathname;
            const host = link_element.host;

            switch(true) {
                case link === path.slice(0,-1):
                case !['shipbob.vipdev.lndo.site', 'www.shipbob.com', 'go.shipbob.com'].includes(host):
                    return null;
                case link[0] == '/' && !link.startsWith(path):
                    link_element.href = `${site_url}${link}`;
                    return null
                default:
                    return null;
            }
        });
    };

    if (window._navigationReady) {
        processLinks();
    } else {
        window.addEventListener('navigation-ready', processLinks, { once: true });
    }
});
